<template>
<div class="chapter">
<div class="inner_page">
<div class="blockquote">
<p class="noindent">The fusion of belief and system produces the militant, a warrior fighting for an idea. In the militant, two figures are conjoined: the cleric and the soldier.</p>
<p class="right"><em class="italic">—Octavio Paz</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm4.vue?3a79eab8